/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
class FaqAccordion {
  /**
   * Run when the document is ready.
   *
   * @return {void}
   */
  docReady() {
    const faqs = document.querySelectorAll(".btn-faq");
    // console.log(faq_title.length);

    if (!faqs) {
      return;
    }

    faqs.forEach((faq) => {
      faq.addEventListener("click", (event) => {
        event.preventDefault();

        // Toggle the FAQ item container background.
        faq.closest("div").classList.toggle("faq-item--active");

        // Toggle the class of Faq title.
        faq.querySelector(".faq-title").classList.toggle("text-ak-red");
        faq.querySelector(".faq-nav-icon").classList.toggle("rotate-180");

        // Toggle the visibility of the FAQ details
        const content = faq.nextElementSibling;
        content.classList.toggle("hidden");
      });
    });
  }
}

new FaqAccordion().docReady();

/* eslint-enable no-console */
